import _ from 'lodash';

export interface PsHttpSSEOptions {
    url: string;
    method?: string;
    data?: Record<string, any>;
    /**
     * 是否需要抛出 abort 错误
     */
    throwErrorWhenClose?: boolean;

    /**
     * 是否需要解析消息
     */
    hasFinalMessage?: (data: Record<string, any>) => boolean;
}

export interface SSEResponse<T> {
    data: T,
    status: boolean,
    error_code: string,
    error_message: string
}

export interface SSEStreamService<T> {

    onOpen(callback: (response: Response) => void): this;

    onMessage(callback: (data: SSEResponse<T>) => void): this;

    onClose(callback: () => void): this;

    onError(callback: (err: any) => void): this;

    /**
     *
     * @param customHeaders 自定义 Headers
     */
    setFetchHeaders: (customHeaders?: Record<string, string>) => this;

    /**
     * 关闭 SSE 连接
     */
    close: () => void;


    start: () => Promise<void>;
}

export interface PsHttpSSE<T> extends SSEStreamService<T> {
    init(options: PsHttpSSEOptions): this;
    /**
     * 消息回调
     * @description 当收到消息时, 会触发该回调
     * @param callback
     * @returns
     */
    onMessage(callback: (data: SSEResponse<T>) => void): this;
    /**
     * 完成回调
     * @description 当返回 status 为 FINISH 时, 会触发该回调
     * @param callback
     * @returns
     */
    onFinish(callback: () => void): this;
    /**
     * 解析错误回调
     * @description 当解析错误时, 会触发该回调
     * @param callback
     * @returns
     */
    onParseError(callback: (error: any) => void): this;
}

export const PsHttpSSE = Symbol('SSEPsHttp');

export const FactoryPsHttpSSE = Symbol('FactoryPsHttpSSE');

export type FactoryPsHttpSSE = <T>() => PsHttpSSE<T>;
